import { render, staticRenderFns } from "./PubchemList.vue?vue&type=template&id=88f04c2e"
import script from "./PubchemList.vue?vue&type=script&lang=js"
export * from "./PubchemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports